import { deleteDoc, doc, getFirestore } from "firebase/firestore";
import { Vacation } from "../types/Vacation";

export const deleteVacation = async (vacation: Vacation) => {
  const db = getFirestore();

  const docRef = doc(db, `Employees/${vacation.idNumber}/Vacations/${vacation.id}`);
  await deleteDoc(docRef);
};